/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import InlineResponse2002 from '../model/InlineResponse2002';
import TransferAcademicRecord from '../model/TransferAcademicRecord';

/**
* TransferAcademicRecords service.
* @module api/TransferAcademicRecordsApi
* @version 1.0
*/
export default class TransferAcademicRecordsApi {

    /**
    * Constructs a new TransferAcademicRecordsApi. 
    * @alias module:api/TransferAcademicRecordsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * get tar from student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/TransferAcademicRecord>} and HTTP response
     */
    transferAcademicRecordsControllerShowWithHttpInfo(studentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling transferAcademicRecordsControllerShow");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [TransferAcademicRecord];
      return this.apiClient.callApi(
        '/transfer-academic-records/students/{student_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get tar from student
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/TransferAcademicRecord>}
     */
    transferAcademicRecordsControllerShow(studentId) {
      return this.transferAcademicRecordsControllerShowWithHttpInfo(studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TransferAcademicRecord} and HTTP response
     */
    transferAcademicRecordsControllerShowCurrentWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling transferAcademicRecordsControllerShowCurrent");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = TransferAcademicRecord;
      return this.apiClient.callApi(
        '/transfer-academic-records/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get tar from id
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TransferAcademicRecord}
     */
    transferAcademicRecordsControllerShowCurrent(id) {
      return this.transferAcademicRecordsControllerShowCurrentWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Upload documentation
     * @param {String} student 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2002} and HTTP response
     */
    transferAcademicRecordsControllerStoreWithHttpInfo(student, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'student' is set
      if (student === undefined || student === null) {
        throw new Error("Missing the required parameter 'student' when calling transferAcademicRecordsControllerStore");
      }

      let pathParams = {
        'student': student
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'file': opts['file'],
        'academic_program_id': opts['academicProgramId']
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2002;
      return this.apiClient.callApi(
        '/transfer-academic-records/students/{student}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload documentation
     * @param {String} student 
     * @param {Object} opts Optional parameters
     * @param {File} opts.file Archivo a subir
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2002}
     */
    transferAcademicRecordsControllerStore(student, opts) {
      return this.transferAcademicRecordsControllerStoreWithHttpInfo(student, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
